export enum SendItdcrActionType {
  ToSalesPerson = 'ToSalesPerson',
  ToItdcrOffice = 'ToItdcrOffice',
  ToPreviousItdcrOffice = 'ToPreviousItdcrOffice'
}

export interface SendItdcrRequest {
  actionType: SendItdcrActionType;
  toItdcrOfficeId?: number | null;
  toNotes?: string;
}
